import { CampaignPageNotificationType, NotificationReason } from "../../types";
import { getNotificationId } from "../helper";

export default function generateNotifications(
  campaignData: {
    data;
    reason: NotificationReason;
    condition: (d) => boolean;
  },
  campaignsObject
) {
  const notifications: Array<CampaignPageNotificationType> = [];

  const { data, reason, condition } = campaignData;

  data.forEach((d) => {
    const campaign = campaignsObject[d.id];
    if (!campaign) return;
    const notificationId = getNotificationId({
      campaign,
      lineitem: {},
      reason:
        reason === NotificationReason.campaignRejectedInstallsHigh &&
        d?.rejectedInstall
          ? `${reason}-${d.rejectedInstall}`
          : reason,
    });

    if (condition(d)) {
      notifications.push({
        id: notificationId,
        campaignId: d.id,
        campaignName: campaign.name,
        reason,
        rejectedInstalls: d.rejectedInstall,
      });
    }
  });

  return notifications;
}
